/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rust_Pure_Crab_LeapInputs */

const en_rust_pure_crab_leap = /** @type {(inputs: Rust_Pure_Crab_LeapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add user`)
};

const de_rust_pure_crab_leap = /** @type {(inputs: Rust_Pure_Crab_LeapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add user" |
*
* @param {Rust_Pure_Crab_LeapInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rust_pure_crab_leap = /** @type {((inputs?: Rust_Pure_Crab_LeapInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rust_Pure_Crab_LeapInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rust_pure_crab_leap(inputs)
	return de_rust_pure_crab_leap(inputs)
});